import { Typography } from 'antd';
import { useMemo } from 'react';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ICompanyWidget } from './ICompanyWidget.tsx';

export interface ICompanyWidgetComponentProps
  extends IWidgetComponentProps<ICompanyWidget> {}

export function CompanyWidgetComponent(props: ICompanyWidgetComponentProps) {
  const { widget } = props;
  const options = useMemo(() => getWidgetProps(props), [props]);
  const visible = useWidgetVisibility(widget, options);

  if (!visible) return null;

  return (
    <>
      {options.preview && (
        <div>
          <Typography.Text type="secondary">
            Configurando un&apos;azienda in questo elemento impostando i campi
            con i relativi &quot;Attributo del titolare della richiesta&quot;,
            tutti i titolari della richiesta presenti all&apos;interno di questo
            elemento saranno collegati all&apos;azienda configurata come legali
            rappresentati.
          </Typography.Text>
        </div>
      )}
      {props.children}
    </>
  );
}
